import { z } from "zod";

export const notificationCampaignSchema = z.object({
  title: z.string().trim().min(1, "Escribe un título").max(120),
  body: z.string().trim().min(1, "Escribe el mensaje").max(1000),
});

export type NotificationCampaignFormValues = z.infer<
  typeof notificationCampaignSchema
>;
